"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.globalPrintStyles = void 0;
const react_1 = require("@stitches/react");
exports.globalPrintStyles = (0, react_1.globalCss)({
    "@media print": {
        "@page": {
            margin: "0.75in !important",
        },
        body: {
            margin: "0 !important",
            backgroundColor: "white",
            "-webkit-print-color-adjust": "exact",
            printColorAdjust: "exact",
        },
        h1: {
            pageBreakAfter: "avoid !important",
        },
        h2: {
            pageBreakAfter: "avoid !important",
        },
        h3: {
            pageBreakAfter: "avoid !important",
        },
        p: {
            breakInside: "avoid",
            pageBreakAfter: "avoid",
        },
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2xvYmFsU3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vY29tcG9uZW50cy9fX3N0eWxlc19fL2dsb2JhbFN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSwyQ0FBNEM7QUFFL0IsUUFBQSxpQkFBaUIsR0FBRyxJQUFBLGlCQUFTLEVBQUM7SUFDekMsY0FBYyxFQUFFO1FBQ2QsT0FBTyxFQUFFO1lBQ1AsTUFBTSxFQUFFLG1CQUFtQjtTQUM1QjtRQUNELElBQUksRUFBRTtZQUNKLE1BQU0sRUFBRSxjQUFjO1lBQ3RCLGVBQWUsRUFBRSxPQUFPO1lBQ3hCLDRCQUE0QixFQUFFLE9BQU87WUFDckMsZ0JBQWdCLEVBQUUsT0FBTztTQUMxQjtRQUNELEVBQUUsRUFBRTtZQUNGLGNBQWMsRUFBRSxrQkFBa0I7U0FDbkM7UUFDRCxFQUFFLEVBQUU7WUFDRixjQUFjLEVBQUUsa0JBQWtCO1NBQ25DO1FBQ0QsRUFBRSxFQUFFO1lBQ0YsY0FBYyxFQUFFLGtCQUFrQjtTQUNuQztRQUNELENBQUMsRUFBRTtZQUNELFdBQVcsRUFBRSxPQUFPO1lBQ3BCLGNBQWMsRUFBRSxPQUFPO1NBQ3hCO0tBQ0Y7Q0FDRixDQUFDLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBnbG9iYWxDc3MgfSBmcm9tIFwiQHN0aXRjaGVzL3JlYWN0XCI7XG5cbmV4cG9ydCBjb25zdCBnbG9iYWxQcmludFN0eWxlcyA9IGdsb2JhbENzcyh7XG4gIFwiQG1lZGlhIHByaW50XCI6IHtcbiAgICBcIkBwYWdlXCI6IHtcbiAgICAgIG1hcmdpbjogXCIwLjc1aW4gIWltcG9ydGFudFwiLFxuICAgIH0sXG4gICAgYm9keToge1xuICAgICAgbWFyZ2luOiBcIjAgIWltcG9ydGFudFwiLFxuICAgICAgYmFja2dyb3VuZENvbG9yOiBcIndoaXRlXCIsXG4gICAgICBcIi13ZWJraXQtcHJpbnQtY29sb3ItYWRqdXN0XCI6IFwiZXhhY3RcIixcbiAgICAgIHByaW50Q29sb3JBZGp1c3Q6IFwiZXhhY3RcIixcbiAgICB9LFxuICAgIGgxOiB7XG4gICAgICBwYWdlQnJlYWtBZnRlcjogXCJhdm9pZCAhaW1wb3J0YW50XCIsXG4gICAgfSxcbiAgICBoMjoge1xuICAgICAgcGFnZUJyZWFrQWZ0ZXI6IFwiYXZvaWQgIWltcG9ydGFudFwiLFxuICAgIH0sXG4gICAgaDM6IHtcbiAgICAgIHBhZ2VCcmVha0FmdGVyOiBcImF2b2lkICFpbXBvcnRhbnRcIixcbiAgICB9LFxuICAgIHA6IHtcbiAgICAgIGJyZWFrSW5zaWRlOiBcImF2b2lkXCIsXG4gICAgICBwYWdlQnJlYWtBZnRlcjogXCJhdm9pZFwiLFxuICAgIH0sXG4gIH0sXG59KTtcbiJdfQ==